import { render, staticRenderFns } from "./ListOfClaimsDialog.vue?vue&type=template&id=53131d4b&scoped=true&"
import script from "./ListOfClaimsDialog.vue?vue&type=script&lang=js&"
export * from "./ListOfClaimsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ListOfClaimsDialog.vue?vue&type=style&index=0&id=53131d4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53131d4b",
  null
  
)

export default component.exports